window.HACIENDOLA = window.HACIENDOLA || {};
window.HACIENDOLA.CUSTOM_PRODUCT_FORM = window.HACIENDOLA.CUSTOM_PRODUCT_FORM || {};
window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS = window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS || {};
window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.afterAddToCart = () => {
    // Espacio para añadir operaciones finales al add to cart
    const siteHeaderCartCount = document.getElementsByClassName('site-header-cart--count')[0];
    fetch('/cart.js')
        .then(res => res.json())
        .then(res => {
            siteHeaderCartCount.classList.add('visible');
            siteHeaderCartCount.dataset.headerCartCount = res.item_count;
        });
};
window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.buyNowButtonClicked = (event) => {
    const target = event.target;
    const variantId = target.dataset.variantId;
    const quantitySelector = document.getElementById(`customProductFormQuantity${variantId}`);
    window.location.href = `/cart/${variantId}:${quantitySelector.value}`;
}
window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.addToCartButtonClicked = async (event) => {
    const target = event.target.tagName === 'SPAN' ? event.target.parentNode : event.target;
    if(!target.classList.contains('processing')) {
        target.classList.add('processing');
        const variantId = target.dataset.variantId;

        const quantitySelector = document.getElementById(`customProductFormQuantity${variantId}`);
        let formData = {
            'items': [{
                'id': variantId,
                'quantity': quantitySelector.value
            }]
        };

        fetch(
            '/cart/add.js',
            {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                }
            )
            .then(res => res.json())
            .then(res => {
                if(res.status == 422) {
                    window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.showErrorMessage(variantId, res.description);
                } else {
                    window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.showSuccessMessage(variantId);
                    window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.afterAddToCart();
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            })
            .finally(() => {
                target.classList.remove('processing');
            });
    }
}
window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.clearMessage = (variantId) => {
    const customProductFormMessage = document.getElementById(`customProductFormMessage${variantId}`);
    customProductFormMessage.innerHTML = '';
    customProductFormMessage.classList.add('hidden');
}
window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.showSuccessMessage = (variantId) => {
    const customProductFormMessage = document.getElementById(`customProductFormMessage${variantId}`);
    customProductFormMessage.innerHTML = `
        <p style="font-weight: bold; font-size: 14px;">Producto añadido a tu carro <i class="fad fa-check-double"></i></p>
    `;
  //<a href="/checkout" style="color: #88BC23; font-size: 14px; font-weight: bold">Finalizar tu compra aquí <i class="fas fa-caret-right"></i></a>
    customProductFormMessage.classList.remove('hidden');
    // setTimeout(() => {window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.clearMessage(variantId)}, 10000);
}

window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.showErrorMessage = (variantId, errorMessage) => {
    const customProductFormMessage = document.getElementById(`customProductFormMessage${variantId}`);
    customProductFormMessage.innerHTML = `<p style="color: #ED6C60; font-weight: bold; font-size: 14px;">${errorMessage}</p>`;
    customProductFormMessage.classList.remove('hidden');
}

const customProductFormATCButton = document.getElementsByName('customProductFormATCButton');
for(const btn of customProductFormATCButton) {
    btn.addEventListener('click', window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.addToCartButtonClicked);
}

const customProductFormBuyNowButton = document.getElementsByName('customProductFormBuyNowButton');
for(const btn of customProductFormBuyNowButton) {
    btn.addEventListener('click', window.HACIENDOLA.CUSTOM_PRODUCT_FORM.FUNCTIONS.buyNowButtonClicked);
}
